export const FETCH_ERROR_FILE_SUCCESS = "FETCH_ERROR_FILE_SUCCESS";
export const FETCH_ERROR_FILE_REQUEST = "FETCH_ERROR_FILE_REQUEST";
export const FETCH_ERROR_FILE_FAILURE = "FETCH_ERROR_FILE_FAILURE";
export const FETCH_ERROR_FILE_RESET = "FETCH_BATCH_LABEL_FILE_RESET";
export const fetchErrorSuccess = (payload) => ({
    type: FETCH_ERROR_FILE_SUCCESS,
    payload,
});
export const fetchErrorRequest = (payload) => ({
    type: FETCH_ERROR_FILE_REQUEST,
    payload,
});
export const fetchErrorFailure = (payload) => ({
    type: FETCH_ERROR_FILE_FAILURE,
    payload,
});
export const fetchErrorReset = () => ({
    type: FETCH_ERROR_FILE_RESET,
});
